import { OnInit, Injectable } from '@angular/core';

@Injectable()
export class LoadingService implements OnInit {
  showLoadingScr: boolean;

  constructor() {
    // Do stuff
  }

  showLoading() {
    this.showLoadingScr = true;
  }

  hideLoading() {
    this.showLoadingScr = false;
  }

  ngOnInit() {
    console.log('showLoading Init');
    this.hideLoading();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/loading/loading.service.ts